export const registerUmamiScript = (umamiScriptUrl: string, websiteId: string, hostUrl?: string) => {
    if (umamiScriptUrl && websiteId) {
        const head = document.getElementsByTagName('head')[0];
        const script = document.createElement('script');
        script.type = 'text/javascript';
        script.src = umamiScriptUrl;
        script.async = true;
        script.defer = true;
        script.setAttribute('data-auto-track', 'false');
        script.setAttribute('data-website-id', websiteId);
        script.setAttribute('data-performance', 'true');
        if (hostUrl) {
            script.setAttribute('data-host-url', hostUrl);
        }
        head.appendChild(script);
    }
}
